import Scrollbar from './ScrollBar';

export default Scrollbar;